/* ─────────────────────────────────────────────────────────────────────────────
   PDP related candles — sections/pdp-related.liquid

   Fetches Shopify's Product Recommendations endpoint and swaps the real
   recommendations in over the server-rendered collection fallback.

   Same shape as every other section script in this theme: IIFE, initSection
   guarded by a data-*-ready attribute so a section can never be initialised
   twice, initAll(scope), then DOMContentLoaded + shopify:section:load.
   ──────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.hasAttribute('data-related-ready')) return;
    root.setAttribute('data-related-ready', '');

    var url = root.getAttribute('data-related-url');
    var grid = root.querySelector('[data-related-grid]');
    if (!url || !grid) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        /* The endpoint returns the section rendered in its
           recommendations.performed branch — a bare grid. Parse it and take
           that grid. */
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var incoming = parsed.querySelector('[data-related-grid]');
        if (!incoming) return;

        /* Nothing came back. Common on a new store, and always the case for
           `complementary` until pairs are configured in Search & Discovery.
           Leave the fallback grid alone rather than emptying the section. */
        if (!incoming.querySelector('.product-card, [class*="product-card"]')) {
          root.classList.remove('pdp-related--pending');
          return;
        }

        grid.innerHTML = incoming.innerHTML;

        /* Injected cards carry [data-reveal] but were never seen by the
           observer that global.js set up on load, so they would sit at
           opacity 0 forever. Re-run reveal over the new nodes only. */
        if (window.PavosUI && typeof window.PavosUI.initReveal === 'function') {
          window.PavosUI.initReveal(grid);
        } else {
          grid.querySelectorAll('[data-reveal]').forEach(function (el) {
            el.classList.add('is-visible');
          });
        }

        /* The section renders with --pending when the fallback found no cards,
           which keeps it hidden so an empty heading never flashes. Now that
           there is content, reveal it. */
        root.classList.remove('pdp-related--pending');
      })
      .catch(function (error) {
        /* Fallback cards are already on the page, so a failed fetch is a
           non-event for the buyer. Only surface it if the section had nothing
           to fall back on. */
        if (root.classList.contains('pdp-related--pending')) {
          root.setAttribute('hidden', '');
        }
        if (window.console && console.warn) console.warn('[pdp-related]', error);
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-related]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
